import { step1Validations, step1 } from "./step1";
import { step2Validations, step2 } from "./step2";
import { step3Validations, step3 } from "./step3";
import { step4Validations, step4 } from "./step4";
import { step5Validations, step5 } from "./step5";
import { step6Validations, step6 } from "./step6";
import { step7Validations, step7 } from "./step7";
import { step8Validations, step8 } from "./step8";
import { step9Validations, step9 } from "./step9";

export default {
  form: {
    ...step1Validations,
    ...step2Validations,
    ...step3Validations,
    ...step4Validations,
    ...step5Validations,
    ...step6Validations,
    ...step7Validations,
    ...step8Validations,
    ...step9Validations
  },
  step1,
  step2,
  step3,
  step4,
  step5,
  step6,
  step7,
  step8,
  step9
};
